<div class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
  <div class="flex flex-column align-items-center justify-content-center">
    <div style="border-radius:56px; padding:0.3rem; background: linear-gradient(180deg, #45367a 10%, #A7A8AC 30%);">
      <div class="w-full surface-card py-8 px-5 sm:px-8 flex flex-column align-items-center" style="border-radius:53px">
        <span class="font-bold text-3xl" style="color: #45367A;">404</span>
        <h1 class="text-900 font-bold text-3xl lg:text-5xl mb-2 uppercase">Página no encontrada</h1>
        <div class="text-600 mb-5">El recurso no esta disponible</div>
      </div>
    </div>
  </div>
</div>